import ko from "knockout";
import template from "./bi-reporting-page.html";
import dataModel from "data-model";
import { useDispatch } from "ko-data-store";
import { isLoading } from "../../../dataStore/actions/appUI";
import powerBiService from "./powerBiService";
import userprofile from "user-profile";
import toastNotify from "geNotyf";

var BiReportingPageViewModel = function () {
  var self = this;
  const dispatch = useDispatch();

  self.selectAgencyModal = ko.observable();

  self.categories = ko.observableArray([]);

  // Scroll-to-top button visibility
  self.showScrollTop = ko.observable(false);
  self.scrollToTop = function () {
    $("html, body").animate({ scrollTop: 0 }, 400);
  };

  // Toggle visibility based on scroll position
  $(window).on("scroll.bi-reporting", function () {
    const scrolled = $(this).scrollTop();
    self.showScrollTop(scrolled > 200);
  });
  // Set initial visibility
  self.showScrollTop($(window).scrollTop() > 200);

  // Cleanup when component is disposed
  self.dispose = function () {
    $(window).off("scroll.bi-reporting");
  };

  self.loadReports = function () {
    dispatch(isLoading(true));

    dataModel
      .ajaxRequest("BI/reports", "get")
      .done(function (data) {
        console.log("[BI] payload:", data);
        // Map directly to the observable
        if (Array.isArray(data.categories)) {
          const mapped = data.categories.map((data) => ({
            ...data,
            links: data.links?.map((x) => ({
              ...x,
            })),
          }));

          self.categories(mapped);
          dispatch(isLoading(false));
        }
      })
      .fail(function (xhr) {
        dispatch(isLoading(false));
        console.error("[BI] failed to load reports:", xhr);
      });
  };

  self.handleLinkClick = function (link) {
    if (!link || (!link.url && !link.biEmbedId)) {
      return;
    }

    if (!link.isEmbedReport) {
      const url = new URL(link.url, window.location.origin);
      window.open(url.toString(), "_blank");
      return;
    }

    // No agencies? User user default?
    if (
      !link.agencies ||
      link.agencies.length === 0 ||
      link.biEmbedId == "3a48b5d2-c4cf-4bd8-8e06-b9973261191c"
    ) {
      const agency = userprofile.agencyExternalId;
      self.openInternalReportWindow({
        reportId: link.biEmbedId,
        workspaceId: link.biWorkspaceId,
        title: link.title,
        agency,
      });
      return;
    }

    // Only one agency, open the link with that agency
    if (link.agencies.length === 1) {
      const agency = link.agencies[0];

      self.openInternalReportWindow({
        reportId: link.biEmbedId,
        workspaceId: link.biWorkspaceId,
        title: link.title,
        agency,
      });
      return;
    }

    // Multiple agencies, show the modal to select one
    const selectedAgency = ko.observable();
    selectedAgency.subscribe((agency) => {
      if (!agency) {
        return;
      }
      self.openInternalReportWindow({
        reportId: link.biEmbedId,
        workspaceId: link.biWorkspaceId,
        title: link.title,
        agency,
      });

      self.selectAgencyModal(null);

      return;
    });

    self.selectAgencyModal({
      selectedAgency: selectedAgency,
      agencies: link.agencies,
    });
  };

  self.openInternalReportWindow = async function (reportOption) {
    try {
      if (!reportOption) return;

      dispatch(isLoading(true));

      const allReports = await powerBiService.getReportsAsync(
        reportOption.workspaceId,
      );
      const matchedReport = (allReports ?? []).find(
        (x) => x.id == reportOption.reportId,
      );

      if (!matchedReport) {
        toastNotify.open({
          message: "Report not found in workspace.",
          type: "error",
          duration: 5000,
        });
      }

      const $containerEl = $("#bi-report-container");

      if ($containerEl && $containerEl.length) {
        $containerEl.height(850);

        const $embedContainer = $(`<div></div>`, {
          id: "bi-embed-container",
        }).css({
          width: "100%",
          height: "100%",
        });
        $containerEl.empty().append($embedContainer);

        await powerBiService.embedTo($embedContainer[0], {
          workspaceId: reportOption.workspaceId,
          reportId: matchedReport.id,
          embedUrl: matchedReport.embedUrl,
          datasetIds: [matchedReport.datasetId],
          username: reportOption.agency,
          roles: ["Agent Security"],
        });

        // Smooth scroll to the embedded report container
        const top = $containerEl.offset() ? $containerEl.offset().top : 0;
        $("html, body").animate({ scrollTop: top - 60 }, 400);
      }
    } catch (err) {
      console.error(err);

      toastNotify.open({
        message: "Error loading report.",
        type: "error",
        duration: 5000,
      });
    } finally {
      dispatch(isLoading(false));
    }
  };

  self.loadReports();
};

export default { viewModel: BiReportingPageViewModel, template: template };
